// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2DqvN","label":"styles_label__S9EmS","icon":"styles_icon__Tm55z"};